import { ReactNode } from 'react';
import styled, { StyleSheetManager } from 'styled-components';
import { shouldForwardProp } from 'styled-components-karnott';
import { colors } from '@karnott/colors';
import { fontFamily } from '@karnott/theme';

export function MapPopup({ archived, children }: { archived?: boolean; children: ReactNode }) {
  return (
    <StyleSheetManager shouldForwardProp={shouldForwardProp} enableVendorPrefixes>
      <PopupWrapper archived={archived}>{children}</PopupWrapper>
    </StyleSheetManager>
  );
}

const PopupWrapper = styled.div<{ archived?: boolean }>`
  display: flex;
  flex-direction: column;
  padding: 2px;
  font-family: ${fontFamily()};
  font-style: ${({ archived }) => (archived ? 'italic' : 'normal')};
  color: ${({ archived }) => (archived ? colors('grey', 'dark') : colors('black', 'dark'))};
`;
